export default __webpack_public_path__ + "static/media/pattern_bg_1.b0fc2b2a.svg";